/**
 * The Payouts page's queries — plan-005 OP-38. Kept beside the screen rather than appended to
 * `src/api/query.ts`, because this unit owns `routes/payouts/**` and the slice, not the shared
 * query file. Every key starts with its own literal namespace, as the shared ones do.
 */
import { queryOptions } from "@tanstack/react-query";

import type { ConsoleGateway } from "../../api/gateway.js";
import type { PayoutStatementQueryView } from "../../api/slice/payout.js";

export const PAYOUT_QUERY_KEY = {
  onlinePaymentStatus: ["online-payment-status"] as const,
  payoutStatement: ["payout-statement"] as const,
  payoutDestination: ["payout-destination"] as const,
};

/** Read by the Payouts page, the wizard's "How callers pay" and the voice agent's Payments setting. */
export const onlinePaymentStatusQuery = (gateway: ConsoleGateway) =>
  queryOptions({
    queryKey: PAYOUT_QUERY_KEY.onlinePaymentStatus,
    queryFn: () => gateway.readOnlinePaymentStatus(),
    staleTime: 30_000,
  });

export const payoutStatementQuery = (gateway: ConsoleGateway, query: PayoutStatementQueryView) =>
  queryOptions({
    queryKey: [...PAYOUT_QUERY_KEY.payoutStatement, query.providerMode, query.from, query.to],
    queryFn: () => gateway.readPayoutStatement(query),
  });

export const payoutDestinationQuery = (gateway: ConsoleGateway) =>
  queryOptions({
    queryKey: PAYOUT_QUERY_KEY.payoutDestination,
    queryFn: () => gateway.readPayoutDestination(),
  });
